import { render } from "./BottomPage.vue?vue&type=template&id=5a03763c&scoped=true"
import script from "./BottomPage.vue?vue&type=script&lang=js"
export * from "./BottomPage.vue?vue&type=script&lang=js"

import "./BottomPage.vue?vue&type=style&index=0&id=5a03763c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a03763c"]])

export default __exports__